import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import { useMedia } from 'use-media'

import { data } from './data'

import styles from './style.module.scss'

export const View = () => {
	const isMobile = useMedia({ minWidth: '768px', maxWidth: '1023px' })
	const isTablet = useMedia({ minWidth: '1024px', maxWidth: '1439px' })
	const isDesktop = useMedia({ minWidth: '1440px' })

	const getLine = () => {
		if (isMobile) return 'line-mobile.png'
		if (isTablet) return 'line-desktop.png'
		if (isDesktop) return 'line-big-desktop.png'

		return 'line-default.png'
	}

	return (
		<Section className={styles.ourMission}>
			<Image className={styles.line} name={getLine()} />
			<div className={styles.topWrapper}>
				<h1 className={styles.heading}>{data.heading}</h1>
				<h2 className={styles.description}>
					платформа цифровых решений <br className={styles.br} /> для кредитования
				</h2>
			</div>
			<div className={styles.imageContainer}>
				<Image name={isTablet || isDesktop ? 'our-mission-big.png' : 'our-mission.png'} />
			</div>
			<div className={styles.bottomWrapper}>
				<p className={styles.mission}>{data.mission}</p>
				<p className={styles.about}>{data.about}</p>
			</div>
		</Section>
	)
}
